import React, { FC } from 'react';
import { IHeroImageCta } from '../../interfaces/umbracoNodes/contentSlices';
import { ContentContainer } from '../base/contentContainer/contentContainer';
import { Column } from '../base/grid';
import Breadcrumbs from '../breadcrumbs-v2';
import * as StyledImageCta from './heroImageCta.styles';
import { RichTextTitleStyled } from './heroImageCta.styles';

interface Props {
	pageId: number;
	content: IHeroImageCta;
}

const HeroImageCta: FC<Props> = ({ pageId, content }) => {
	return (
		<StyledImageCta.ImageCtaWrapper>
			<ContentContainer>
				<StyledImageCta.ColumnsStyled>
					<Column desktopSmall={1 / 2} desktopLarge={5 / 12} marginBottom={0}>
						<StyledImageCta.TextWrapper>
							{content.Values.DisplayBreadcrumbs && <Breadcrumbs pageId={pageId} />}
							<RichTextTitleStyled content={content.Values.Title} />
							<StyledImageCta.DescriptionRichText content={content.Values.Description} />
							{content.Values.Button && (
								<StyledImageCta.ButtonStyled
									title={content.Values.Button.Name}
									href={content.Values.Button.Url}
									target={content.Values.Button.Target}
								/>
							)}
						</StyledImageCta.TextWrapper>
					</Column>
					<Column desktopSmall={1 / 2} marginBottom={0}>
						<StyledImageCta.ImageWrapper>
							<StyledImageCta.Image
								src={content.Values.Image.Src}
								sizes="(max-width: 700px), (max-height: 680px)"
							/>
						</StyledImageCta.ImageWrapper>
					</Column>
				</StyledImageCta.ColumnsStyled>
			</ContentContainer>
		</StyledImageCta.ImageCtaWrapper>
	);
};

export default HeroImageCta;
